function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from "react";
import asUploadButton from "./asUploadButton";
const UploadButton = asUploadButton(/*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement("button", _extends({
  ref: ref
}, props))));
export default UploadButton;